// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Country$OrcaPaymentPage from "./Country.bs.js";

let countryDataRef = {
  contents: Country$OrcaPaymentPage.country
};

let stateDataRef = {
  contents: null
};

export {
  countryDataRef,
  stateDataRef,
}
/* No side effect */
